import { Popover } from '@ksyos/design-system';
import { groupBy } from 'lodash';
import type {
    IRight,
    IServiceConsumerRight,
    IServiceEmploymentRight,
    IServiceProviderRight,
    IServiceReaderRight,
    IServiceSupervisorRight,
} from './PersonalSettingsCarePathsOverview';
import { formatRight, formatServiceEmploymentRight } from '../../../../utils/formatRight';

interface IPersonalSettingsCarePathOverviewDetailsServiceGroupRightsCellProps {
    rightsInServiceGroup: IRight[];
    serviceGroupNameArray: string[];
    serviceGroupNameIndex: number;
}

interface IRightsGroupedByServiceType {
    serviceConsumer?: IServiceConsumerRight[];
    serviceEmployment?: IServiceEmploymentRight[];
    serviceProvider?: IServiceProviderRight[];
    serviceReader?: IServiceReaderRight[];
    serviceSupervisor?: IServiceSupervisorRight[];
}

export function PersonalSettingsCarePathOverviewDetailsServiceGroupRightsCell(
    props: IPersonalSettingsCarePathOverviewDetailsServiceGroupRightsCellProps
) {
    const formattedRights = formatRights(props.rightsInServiceGroup);

    if (formattedRights.length < 30) {
        return <>{formattedRights}</>;
    }

    return <Popover content={formattedRights}>{formattedRights.substring(0, 30)}...</Popover>;
}

function formatRights(rights: IRight[]) {
    if (!rights) {
        return '';
    }
    const rightsGroupedByServiceType: IRightsGroupedByServiceType = groupBy(rights, (right) => right.rightType);

    const formattedRights: string[] = [];
    if (rightsGroupedByServiceType.serviceConsumer?.length) {
        for (const serviceConsumerRight of rightsGroupedByServiceType.serviceConsumer) {
            formattedRights.push(formatRight(serviceConsumerRight));
        }
    }
    if (rightsGroupedByServiceType.serviceProvider?.length) {
        for (const serviceProviderRight of rightsGroupedByServiceType.serviceProvider) {
            formattedRights.push(formatRight(serviceProviderRight));
        }
    }
    if (rightsGroupedByServiceType.serviceSupervisor?.length) {
        for (const serviceSupervisorRight of rightsGroupedByServiceType.serviceSupervisor) {
            formattedRights.push(formatRight(serviceSupervisorRight));
        }
    }
    if (rightsGroupedByServiceType.serviceReader?.length) {
        formattedRights.push(formatRight(rightsGroupedByServiceType.serviceReader[0]));
    }
    if (rightsGroupedByServiceType.serviceEmployment?.length) {
        formattedRights.push(formatServiceEmploymentRight(rightsGroupedByServiceType.serviceEmployment[0]));
    }

    return formattedRights.join('\n');
}
